import { render, staticRenderFns } from "./OperatHeader.vue?vue&type=template&id=2e147bd5&scoped=true"
import script from "./OperatHeader.vue?vue&type=script&lang=js"
export * from "./OperatHeader.vue?vue&type=script&lang=js"
import style0 from "./OperatHeader.vue?vue&type=style&index=0&id=2e147bd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e147bd5",
  null
  
)

export default component.exports